export const AUTH_MODAL_EVENT = 'barbershop:open-auth';

/** Open the header sign-in / sign-up modal from any public page. */
export function openAuthModal(type = 'signin') {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(AUTH_MODAL_EVENT, { detail: { type } }));
}
